export const toSlug = (value: string) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const indiaSupport = {
  whatsappDisplay: "+91 98208 99007",
  whatsappHref: "https://wa.me/919820899007",
  phoneDisplay: "+91 22 4000 3434",
  phoneHref: "tel:+912240003434",
  email: "holidays@get2vacations.in",
  emailHref: "mailto:holidays@get2vacations.in",
} as const;

export type HomeFloatingCard = {
  name: string;
  tag: string;
  image: string;
};

export const homeFloatingCards: HomeFloatingCard[] = [
  {
    name: "Switzerland",
    tag: "Luxury",
    image:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Thailand",
    tag: "Budget",
    image:
      "https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Vietnam",
    tag: "Trending",
    image:
      "https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Japan",
    tag: "Luxury",
    image:
      "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=600&q=80",
  },
];

export const aboutHighlights = [
  {
    label: "Countries Supported",
    value: "50+",
    description: "Worldwide holiday and visa support for Indian travellers.",
  },
  {
    label: "Visa Applications Handled",
    value: "1,000+",
    description: "End-to-end guidance across popular outbound destinations.",
  },
  {
    label: "Support Availability",
    value: "24/7",
    description: "Customer assistance before, during, and after travel.",
  },
] as const;

export type DestinationCategory =
  | "Honeymoon"
  | "Family"
  | "Adventure"
  | "Cultural";

export type DestinationRegion =
  | "Europe"
  | "Asia"
  | "Middle East"
  | "Africa"
  | "Oceania";

export type DestinationTravelType = "Luxury" | "Budget" | "Family" | "Honeymoon"| "Cultural" | "Adventure";
export type DestinationSeason = "Summer" |"Monsoon" |"Autumn" |"Spring" | "Winter";
export type DestinationTabFilter = "All" | "Popular" | "New";
export type DestinationRegionFilter = "All Regions" | "Europe" | "Asia" | "Africa" | "Americas" | "Middle East";
export type DestinationTravelTypeFilter = "All Types" | DestinationTravelType;
export type DestinationSeasonFilter = "Any Season" | DestinationSeason;

export type DestinationBrowseFilters = {
  tab: DestinationTabFilter;
  region: DestinationRegionFilter;
  travelType: DestinationTravelTypeFilter;
  season: DestinationSeasonFilter;
};

export const destinationBrowseOptions = {
  tabs: ["All", "Popular", "New"] as DestinationTabFilter[],
   regions: [
    "All Region",
    "Europe",
    "Asia",
    "Middle East",
    "Africa",
    // "Oceania",
    "Americas"
  ]  as DestinationRegionFilter[],
  travelTypes: [
    "All",
    "Honeymoon",
    // "Budget",
    "Family",
    "Cultural",
    "Adventure",
  ] as DestinationTravelTypeFilter[],
  seasons: ["Any Season", "Summer", "Monsoon", "Autumn", "Spring", "Winter"] as DestinationSeasonFilter[],
} as const;

export type DestinationEntry = {
  id: number;
  name: string;
  slug: string;
  category: DestinationCategory;
  image: string;
  description: string;
  packages: number;
  rating: number;
  region: DestinationRegion;
  travelType: DestinationTravelType;
  season: DestinationSeason;
  isPopular: boolean;
  isNew: boolean;
};

const destinationEntriesSeed: Omit<DestinationEntry, "slug">[] = [
  {
    id: 1,
    name: "Maldives",
    category: "Honeymoon",
    image:
      "https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&w=900&q=80",
    description:
      "Overwater villas, turquoise lagoons, and candlelit island escapes.",
    packages: 8,
    rating: 4.9,
    region: "Asia",
    travelType: "Luxury",
    season: "Winter",
    isPopular: true,
    isNew: false,
  },
  {
    id: 2,
    name: "Bali",
    category: "Honeymoon",
    image:
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=900&q=80",
    description:
      "Temple sunsets, private pool villas, and tropical honeymoon moments.",
    packages: 10,
    rating: 4.8,
    region: "Asia",
    travelType: "Luxury",
    season: "Summer",
    isPopular: true,
    isNew: false,
  },
  {
    id: 3,
    name: "Switzerland",
    category: "Honeymoon",
    image:
      "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?auto=format&fit=crop&w=900&q=80",
    description:
      "Scenic trains, alpine stays, and romantic mountain views for couples.",
    packages: 9,
    rating: 4.9,
    region: "Europe",
    travelType: "Luxury",
    season: "Summer",
    isPopular: true,
    isNew: false,
  },
  {
    id: 4,
    name: "Greece",
    category: "Honeymoon",
    image:
      "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=900&q=80",
    description:
      "Island-hopping romance, whitewashed towns, and sunset dinners.",
    packages: 7,
    rating: 4.7,
    region: "Europe",
    travelType: "Luxury",
    season: "Summer",
    isPopular: false,
    isNew: true,
  },
  {
    id: 5,
    name: "Mauritius",
    category: "Honeymoon",
    image:
      "https://images.unsplash.com/photo-1589979481223-deb893043163?auto=format&fit=crop&w=900&q=80",
    description:
      "Beachfront resorts, lagoon cruises, and easy luxury for couples.",
    packages: 6,
    rating: 4.7,
    region: "Africa",
    travelType: "Luxury",
    season: "Winter",
    isPopular: false,
    isNew: false,
  },
  {
    id: 6,
    name: "Singapore",
    category: "Family",
    image:
      "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?auto=format&fit=crop&w=900&q=80",
    description:
      "Theme parks, family attractions, and stress-free city travel.",
    packages: 9,
    rating: 4.8,
    region: "Asia",
    travelType: "Family",
    season: "Summer",
    isPopular: true,
    isNew: false,
  },
  {
    id: 7,
    name: "Dubai",
    category: "Family",
    image:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=900&q=80",
    description:
      "Desert safaris, iconic attractions, and family-friendly short breaks.",
    packages: 12,
    rating: 4.8,
    region: "Middle East",
    travelType: "Family",
    season: "Winter",
    isPopular: true,
    isNew: false,
  },
  {
    id: 8,
    name: "Thailand",
    category: "Family",
    image:
      "https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?auto=format&fit=crop&w=900&q=80",
    description:
      "Value-packed beaches, islands, and fun itineraries for every age.",
    packages: 13,
    rating: 4.7,
    region: "Asia",
    travelType: "Budget",
    season: "Winter",
    isPopular: true,
    isNew: false,
  },
  {
    id: 9,
    name: "Malaysia",
    category: "Family",
    image:
      "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?auto=format&fit=crop&w=900&q=80",
    description:
      "Easy city-and-island combinations with strong value for families.",
    packages: 7,
    rating: 4.6,
    region: "Asia",
    travelType: "Family",
    season: "Summer",
    isPopular: false,
    isNew: true,
  },
  {
    id: 10,
    name: "UK",
    category: "Family",
    image:
      "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=900&q=80",
    description:
      "Museums, heritage cities, and classic family sightseeing routes.",
    packages: 5,
    rating: 4.6,
    region: "Europe",
    travelType: "Family",
    season: "Summer",
    isPopular: false,
    isNew: false,
  },
  {
    id: 11,
    name: "New Zealand",
    category: "Adventure",
    image:
      "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?auto=format&fit=crop&w=900&q=80",
    description:
      "Epic road trips, glacier views, and outdoor adventures worth the haul.",
    packages: 6,
    rating: 4.8,
    region: "Oceania",
    travelType: "Budget",
    season: "Summer",
    isPopular: false,
    isNew: false,
  },
  {
    id: 12,
    name: "South Africa",
    category: "Adventure",
    image:
      "https://images.unsplash.com/photo-1523805009345-7448845a9e53?auto=format&fit=crop&w=900&q=80",
    description:
      "Safari circuits, scenic coastlines, and thrill-led group journeys.",
    packages: 6,
    rating: 4.7,
    region: "Africa",
    travelType: "Budget",
    season: "Winter",
    isPopular: false,
    isNew: true,
  },
  {
    id: 13,
    name: "Vietnam",
    category: "Adventure",
    image:
      "https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=900&q=80",
    description:
      "Trending for cruise escapes, local culture, and value-driven adventure.",
    packages: 9,
    rating: 4.8,
    region: "Asia",
    travelType: "Budget",
    season: "Winter",
    isPopular: false,
    isNew: true,
  },
  {
    id: 14,
    name: "Norway",
    category: "Adventure",
    image:
      "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?auto=format&fit=crop&w=900&q=80",
    description:
      "Fjords, northern landscapes, and dramatic outdoor experiences.",
    packages: 5,
    rating: 4.8,
    region: "Europe",
    travelType: "Luxury",
    season: "Winter",
    isPopular: false,
    isNew: false,
  },
  {
    id: 15,
    name: "Kenya",
    category: "Adventure",
    image:
      "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?auto=format&fit=crop&w=900&q=80",
    description:
      "Maasai Mara safaris, Rift Valley lakes, and Amboseli wildlife circuits.",
    packages: 2,
    rating: 4.7,
    region: "Africa",
    travelType: "Budget",
    season: "Winter",
    isPopular: false,
    isNew: false,
  },
  {
    id: 16,
    name: "Italy",
    category: "Cultural",
    image:
      "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=900&q=80",
    description:
      "Art cities, scenic countryside, and iconic Europe-first itineraries.",
    packages: 11,
    rating: 4.8,
    region: "Europe",
    travelType: "Luxury",
    season: "Summer",
    isPopular: true,
    isNew: false,
  },
  {
    id: 17,
    name: "Japan",
    category: "Cultural",
    image:
      "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=900&q=80",
    description:
      "Temples, city energy, seasonal beauty, and premium cultural travel.",
    packages: 10,
    rating: 4.9,
    region: "Asia",
    travelType: "Luxury",
    season: "Summer",
    isPopular: true,
    isNew: true,
  },
  {
    id: 18,
    name: "Egypt",
    category: "Cultural",
    image:
      "https://images.unsplash.com/photo-1539650116574-75c0c6d73f6e?auto=format&fit=crop&w=900&q=80",
    description:
      "Ancient wonders, Nile cruises, and history-rich escorted holidays.",
    packages: 7,
    rating: 4.7,
    region: "Africa",
    travelType: "Budget",
    season: "Winter",
    isPopular: false,
    isNew: false,
  },
  {
    id: 19,
    name: "Turkey",
    category: "Cultural",
    image:
      "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=900&q=80",
    description:
      "Mosques, markets, and memorable multi-city journeys across cultures.",
    packages: 8,
    rating: 4.8,
    region: "Middle East",
    travelType: "Budget",
    season: "Summer",
    isPopular: false,
    isNew: false,
  },
  {
    id: 20,
    name: "Spain",
    category: "Cultural",
    image:
      "https://images.unsplash.com/photo-1543783207-ec64e4d95325?auto=format&fit=crop&w=900&q=80",
    description:
      "Culture, coastlines, and energetic city breaks for first-time Europe trips.",
    packages: 7,
    rating: 4.7,
    region: "Europe",
    travelType: "Luxury",
    season: "Summer",
    isPopular: false,
    isNew: true,
  },
];

export const destinationEntries: DestinationEntry[] = destinationEntriesSeed.map(
  (destination) => ({
    ...destination,
    slug: toSlug(destination.name),
  }),
);

const francePopularDestination: DestinationEntry = {
  id: 21,
  name: "France",
  slug: "france",
  category: "Cultural",
  image:
    "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?auto=format&fit=crop&w=900&q=80",
  description:
    "Classic Europe with romantic cities, alpine routes, and iconic landmarks.",
  packages: 10,
  rating: 4.8,
  region: "Europe",
  travelType: "Luxury",
  season: "Summer",
  isPopular: true,
  isNew: false,
};

const findDestination = (slug: string) =>
  destinationEntries.find((destination) => destination.slug === slug);

export const homePopularDestinations = [
  findDestination("switzerland"),
  francePopularDestination,
  findDestination("italy"),
  findDestination("bali"),
  findDestination("thailand"),
  findDestination("dubai"),
].filter((destination): destination is DestinationEntry => Boolean(destination));

export const destinationInquiryOptions = [
  ...new Set(destinationEntries.map((destination) => destination.name)),
];

export type SeasonIconKey = "leaf" | "sun" | "autumn" | "snow";

export type SeasonHighlight = {
  title: "Spring" | "Summer" | "Autumn" | "Winter";
  duration: string;
  description: string;
  tag: string;
  color: string;
  bg: string;
    iconKey: SeasonIconKey;
};

export const switzerlandSeasonHighlights: SeasonHighlight[] = [
  {
    title: "Spring",
    duration: "Mar-May",
    description: "Pleasant weather for scenic rail journeys and lakeside towns.",
    tag: "Recommended",
    color: "text-green-600",
    bg: "bg-green-50",
        iconKey: "leaf",

  },
  {
    title: "Summer",
    duration: "Jun-Aug",
    description: "Peak season with the best weather for mountain and city touring.",
    tag: "Best Time",
    color: "text-yellow-600",
    bg: "bg-yellow-50",
        iconKey: "leaf",

  },
  {
    title: "Autumn",
    duration: "Sep-Nov",
    description: "Scenic views, lighter crowds, and crisp weather across the Alps.",
    tag: "Recommended",
    color: "text-orange-600",
    bg: "bg-orange-50",
        iconKey: "leaf",

  },
  {
    title: "Winter",
    duration: "Dec-Feb",
    description: "Snow experiences, festive markets, and alpine winter escapes.",
    tag: "Best Time",
    color: "text-blue-600",
    bg: "bg-blue-50",
        iconKey: "sun",

  },
];

export const visaPreviewCards = [
  {
    title: "Schengen Visa",
    description: "Europe holiday assistance",
  },
  {
    title: "USA Visa",
    description: "Visitor visa support",
  },
  {
    title: "UK Visa",
    description: "Tourism and family visits",
  },
  {
    title: "Worldwide Visa",
    description: "Support across major outbound destinations",
  },
] as const;

export type VisaDestinationFact = {
  label: string;
  value: string;
};

export type VisaDestinationDetail = {
  heroImage?: string;
  heroDescription: string;
  overviewTitle: string;
  overviewParagraphs: string[];
  factsTitle: string;
  facts: VisaDestinationFact[];
  requirementsTitle: string;
  requirements: string[];
  note?: string;
};

export type VisaDestination = {
  title: string;
  slug: string;
  subtitle: string;
  image: string;
  processing: string;
  support: string;
  detail: VisaDestinationDetail;
};

type VisaDestinationSeed = Omit<VisaDestination, "slug" | "detail"> & {
  detail?: Partial<VisaDestinationDetail>;
};

const defaultVisaFacts: VisaDestinationFact[] = [
  {
    label: "Processing",
    value: "Depends on profile",
  },
  {
    label: "Stay",
    value: "As per visa issued",
  },
  {
    label: "Validity",
    value: "Based on approval",
  },
  {
    label: "Category",
    value: "Tourist / Visit",
  },
  {
    label: "Entry",
    value: "Single or multiple",
  },
  {
    label: "Fees",
    value: "Shared on request",
  },
];

const defaultVisaRequirements = [
  "Original passport with at least 6 months validity and blank pages.",
  "Recent passport-size photographs as per destination requirements.",
  "Financial proof such as bank statements and supporting income documents.",
  "Employment proof, business proof, or sponsor documents when applicable.",
  "Tentative flight and hotel details if requested during the application.",
  "Travel insurance whenever the destination or category requires it.",
];

const buildVisaDestination = (
  destination: VisaDestinationSeed,
): VisaDestination => ({
  ...destination,
  slug: toSlug(destination.title),
  detail: {
    heroDescription:
      destination.detail?.heroDescription ??
      `${destination.subtitle}. We guide Indian travellers through documentation, application readiness, and practical next steps for ${destination.title} visa requests.`,
    heroImage: destination.detail?.heroImage ?? destination.image,
    overviewTitle:
      destination.detail?.overviewTitle ??
      `${destination.title} visa support tailored to your travel plans.`,
    overviewParagraphs:
      destination.detail?.overviewParagraphs ?? [
        `${destination.title} remains a strong choice for travellers planning holidays, family visits, or city breaks abroad. Our team helps you organize the core paperwork and understand the flow before you submit.`,
        "Requirements can vary by traveller profile, travel history, and embassy expectations, so we keep the guidance practical and easy to follow from the first inquiry onward.",
      ],
    factsTitle: destination.detail?.factsTitle ?? "Application Snapshot",
    facts: destination.detail?.facts ?? defaultVisaFacts,
    requirementsTitle:
      destination.detail?.requirementsTitle ?? "Common Visa Requirements",
    requirements:
      destination.detail?.requirements ?? defaultVisaRequirements,
    note:
      destination.detail?.note ??
      "Final documentation can vary slightly depending on your traveller profile and the issuing authority.",
  },
});

const visaDestinationSeeds: VisaDestinationSeed[] = [
  {
    title: "Schengen",
    subtitle: "For Europe itineraries and multi-country holidays",
    image:
      "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?auto=format&fit=crop&w=900&q=80",
    processing: "Checklist and appointment guidance",
    support: "Popular for Switzerland, France, and Italy plans",
    detail: {
      heroImage:
        "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?auto=format&fit=crop&w=1600&q=80",
      heroDescription:
        "The Schengen Area is comprised of 26 countries that have agreed to allow free movement of their citizens within this area as a single country. Of the 26 countries bound by the Schengen Agreement, 22 are part of the EU and the other 4 are part of the EFTA.",
      overviewTitle:
        "A single visa route for multi-country Europe holidays.",
      overviewParagraphs: [
        "Schengen visas are a common choice for travellers planning trips across Europe, especially when the itinerary covers multiple countries such as Switzerland, France, Italy, or Spain under one broader holiday plan.",
        "We help organise the basic application flow, highlight the core documentation typically checked during tourist submissions, and support you with practical next steps before your appointment or file review.",
      ],
      factsTitle: "Schengen Visa Fees",
      facts: [
        {
          label: "Processing time",
          value: "15 Days",
        },
        {
          label: "Stay Period",
          value: "15 Days",
        },
        {
          label: "Validity upto",
          value: "15 Days",
        },
        {
          label: "Category",
          value: "Tourist",
        },
        {
          label: "Entry",
          value: "Single",
        },
        {
          label: "Fee",
          value: "AED 250*",
        },
      ],
      requirementsTitle: "Schengen Visa Requirements",
      requirements: [
        "Original Passport Required (6 month validity with at least two blank page).",
        "Valid UAE residence Visa with 90 days validity.",
        "Original NOC letter stating salary, designation, joining date, travel purpose for employee addressing to the concerned Consulate / Embassy. Valid Trade License copy, Self-Introduction letter stating monthly income, passport details for Partners, Investors & Owners.",
        "3 Recent Photograph with White Background (3.5*4.5 CM).",
        "Latest 6 months online bank statement with bank stamp or original bank statement.",
        "Invitation letter from friend or relative can be additional advantage.",
        "Invitation letter required for Business visa.",
      ],
      note: "Urgent Service available with additional charges.",
    },
  },
  {
    title: "UK",
    subtitle: "Visitor visa support for leisure and family travel",
    image:
      "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=900&q=80",
    processing: "Application review and document support",
    support: "Ideal for family holidays and city breaks",
  },
  {
    title: "USA",
    subtitle: "Travel assistance for tourism and holiday visits",
    image:
      "https://images.unsplash.com/photo-1500916434205-0c77489c6cf7?auto=format&fit=crop&w=900&q=80",
    processing: "DS-160 support and interview prep",
    support: "Structured help for first-time applicants",
  },
  {
    title: "Australia",
    subtitle: "Smooth support for leisure and long-haul holidays",
    image:
      "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?auto=format&fit=crop&w=900&q=80",
    processing: "Document guidance and application review",
    support: "Well suited for family and adventure travel",
  },
  {
    title: "Singapore",
    subtitle: "Fast support for short holiday getaways",
    image:
      "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?auto=format&fit=crop&w=900&q=80",
    processing: "Quick checklist and submission support",
    support: "A favorite for family trips from India",
  },
];

export const visaDestinations: VisaDestination[] =
  visaDestinationSeeds.map(buildVisaDestination);

export const visaDestinationMap = new Map(
  visaDestinations.map((destination) => [destination.slug, destination]),
);
